import React from 'react';
import { Box, Text } from 'pounceV2';
import { useTheme } from '@mui/material';
import EditorLoaderV3 from './EditorLoaderV3';

const EditorWrapperV3 = ({
  children,
  placeholder,
  value,
}: {
  children: React.ReactNode;
  placeholder: string;
  value: string;
  minHeight: number;
}) => {
  const {
    palette: { tokens, componentTokens },
  } = useTheme();
  return (
    <React.Suspense fallback={<EditorLoaderV3 />}>
      <Box
        position="relative"
        width="100%"
        sx={{
          '*': {
            lineHeight: 'typical',
          },
          // Custom css classes for decoration
          '.monaco-inline-decoration': {
            cursor: 'pointer',
            textDecoration: 'underline dotted brown',
            fontWeight: 'bold',
            fontStyle: 'oblique',
          },
          '.monaco-line-decoration': {
            backgroundColor: tokens?.content.text.semantic.error[3],
            width: '4px !important',
          },
          '.monaco-removed-line-decoration': {
            marginLeft: 1,
            width: '0 !important',
            height: '0 !important',
            borderLeftColor: tokens?.background.semantic.error[5],
            borderLeftStyle: 'solid',
            borderLeftWidth: 5,
            borderTop: '5px solid transparent',
            borderBottom: '5px solid transparent',
          },
          '.monaco-added-line-decoration': {
            backgroundColor: tokens?.background.semantic.success[4],
            marginLeft: 1,
            width: '4px !important',
          },
          '.monaco-modified-line-decoration': {
            marginLeft: 1,
            background: `repeating-linear-gradient(
              45deg,
              #34415B,
              #34415B 2.5px,
              #516079 2.5px,
              #516079 5px
            )`,
            width: '4px !important',
          },
          '.monaco-glyph-error': {
            backgroundColor: tokens?.background.semantic.error[3],
            borderRadius: 'circle',
            marginLeft: 1,
          },
          '.monaco-glyph-error::after': {
            // @ts-ignore
            content: '"!"',
          },
          // default widget z-index is 50, we want it to be above the editor
          // but below the side sheet (z-index 10)
          '.monaco-editor .find-widget': {
            zIndex: 1,
          },
        }}
      >
        {children}
        {placeholder && !value && (
          <Text
            top={8}
            fontFamily="mono"
            fontWeight="medium"
            left={55}
            position="absolute"
            pointerEvents="none"
            color={componentTokens?.inputs.colors.normal.text.inputText.resting}
            fontStyle="italic"
            whiteSpace="pre-wrap"
          >
            {placeholder}
          </Text>
        )}
      </Box>
    </React.Suspense>
  );
};

export default EditorWrapperV3;
